import axios from 'axios'
import Vuex    from 'vuex'
import Vue          from 'vue'
Vue.use(Vuex)

import { storeData } from '../boot/store.js'
var store = new Vuex.Store(storeData);

const baseUrl = process.env.NODE_ENV === 'development'
  ? 'http://127.0.0.1:8000/api'
  : '/api'

// Json content type headers
const jsonMethods = ['post', 'put', 'delete']
jsonMethods.forEach(method => {
  axios.defaults.headers[method].Accept = 'application/json'
  axios.defaults.headers[method]['Content-Type'] = 'application/json'
})
axios.defaults.headers['Authorization'] = 'Bearer ' + localStorage.token

// This function transforms the data before sending it
const transformPayload = payload => {

  Object.keys(payload).forEach(key => {
    // If it's a boolean transform it to 1 for true 0 for false
    // this is required by most boolean fields in the backend
    if (typeof payload[key] === 'boolean') {
      payload[key] = payload[key] ? 1 : 0
    }
  })
  return payload
}

const allowedMethods = ['get', 'post', 'put', 'delete']
const Http = {
  call: (method, endpoint, payload) => {
    if (allowedMethods.indexOf(method) === -1) {
      const error = method + 'method not allowed'
      return Promise.reject({
        response: {info: error, status: 500}
      })
    }
    payload = transformPayload(payload || {})
    if (payload && method === 'get') payload = {params: payload}
    if (endpoint[0] !== '/') endpoint = '/' + endpoint
    axios.defaults.headers['Authorization'] = 'Bearer ' + localStorage.token
    store.commit('loading', true)
    return axios[method](baseUrl + endpoint, payload)
  },
  get: (endpoint, params) => Http.call('get', endpoint, params),
  post: (endpoint, body) => Http.call('post', endpoint, body),
  put: (endpoint, body) => Http.call('put', endpoint, body),
  delete: (endpoint, body) => Http.call('delete', endpoint, body),
  axios
}

export default Http
